import { UserCredential } from "firebase/auth";

import { Dispatch, GetState } from "common/types";

import { getUserLinkedProviders } from "services/firebase/auth/ssoProvider";

import {
  analyticsLogSignUp,
  logSignUpEventByAccountType
} from "seneca-common/utils/senecaAnalytics";

import { setRegionPreference } from "features/user";
import { FirebaseUserInfo } from "features/user/actions/auth/sso/types";
import extractUserDetails from "features/user/actions/auth/sso/utils/extractUserDetails";
import { reconcileData } from "features/user/actions/auth/utils";
import { saveUserInfo } from "features/user/actions/userInfo";
import { setUserAsSignedUpBefore } from "features/user/utils/signedUpBefore";

export default function completeSignup({
  userCredential,
  userProfile,
  accountType,
  regionBeforeAuthenticating
}: {
  userCredential: UserCredential;
  userProfile?: FirebaseUserInfo["profile"];
  accountType?: string;
  regionBeforeAuthenticating?: string | null;
}) {
  const userDetails = extractUserDetails({
    authInfo: userCredential,
    userProfile
  });

  return async function (dispatch: Dispatch, getState: GetState) {
    accountType && logSignUpEventByAccountType(accountType);
    analyticsLogSignUp(getState());
    setUserAsSignedUpBefore();

    await dispatch(
      saveUserInfo({
        ...userDetails,
        ...(accountType && { type: accountType }),
        providerData: getUserLinkedProviders()
      })
    );

    await dispatch(reconcileData());

    if (regionBeforeAuthenticating) {
      dispatch(setRegionPreference(regionBeforeAuthenticating));
    }
  };
}
